import { findTransform } from "./find-transform";
import { getFilesTransforms } from "./get-transforms";

export default function rawPasteFilesHandler(files) {
  const blocks = files
    .reduce((accumulator, file) => {
      const transformation = findTransform(getFilesTransforms(), (transform) =>
        transform.isMatch([file]),
      );
      if (transformation) {
        accumulator.push(transformation.transform([file]));
      }
      return accumulator;
    }, [])
    .flat();
  if (!blocks.length) {
    return;
  }

  return blocks;
}
